import React from 'react'
import { Text } from '@/components/common'
import { Checkmark } from '@/components/svg'
import { formatMoney } from '@/utils'

export interface Props {
  idx: number
  amount: number
  title: string
  description?: string
  status: 'default' | 'in-progress' | 'complete'
}

const StretchGoalsModalListItem: React.FC<Props> = ({
  idx,
  amount,
  title,
  description,
  status,
}) => {
  const formattedAmount = formatMoney(amount, {
    zeroFractionDigits: true,
  })

  return (
    <li
      key={amount}
      className="border-b border-gray-8 bg-white p-4 last:border-b-0"
    >
      <div className="flex items-start">
        <Text as="div" preset="heading.sm" className="mb-2">
          Goal {idx}: {formattedAmount}
        </Text>

        {status === 'in-progress' && (
          <div className="ml-auto rounded-sm bg-copper-3 px-2 py-1 sm:py-[5px]">
            <Text as="div" preset="heading.eyebrow" className="leading-none">
              In Progress
            </Text>
          </div>
        )}

        {status === 'complete' && (
          <div className="ml-auto mt-[3px] flex items-center">
            <Text as="div" preset="heading.eyebrow" className="leading-none">
              Completed
            </Text>
            <div className="ml-1 h-[13px] w-[13px] rounded-full bg-oxide p-[2px]">
              <Checkmark className="h-[9px] w-[9px] text-white" />
            </div>
          </div>
        )}
      </div>
      <Text as="div" preset="body.md" className="font-semibold text-gray-5">
        {title}
      </Text>
      {description && (
        <Text as="div" preset="body.md" className="mt-1 text-gray-5">
          {description}
        </Text>
      )}
    </li>
  )
}

export default StretchGoalsModalListItem
